import { render } from "./SalesRatioControlConfigForm.vue?vue&type=template&id=2469efa4&scoped=true&ts=true"
import script from "./SalesRatioControlConfigForm.vue?vue&type=script&lang=ts"
export * from "./SalesRatioControlConfigForm.vue?vue&type=script&lang=ts"

import "./SalesRatioControlConfigForm.vue?vue&type=style&index=0&id=2469efa4&scoped=true&lang=css"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2469efa4"]])

export default __exports__